"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterDefinition = void 0;
const static_service_1 = require("@wix/static-service");
exports.RouterDefinition = (0, static_service_1.defineStaticService)('@wix/viewer-service-router');
//# sourceMappingURL=index.js.map